import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import FAQEditor from './pages/FAQEditor';
import PublicFAQ from './pages/PublicFAQ';
import Home from './pages/Home';
import ManualDashboard from './pages/ManualDashboard';
import PublicManual from './pages/PublicManual';
import LiveEditManual from './pages/LiveEditManual';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
            <Navbar />
            <main className="container mx-auto px-4 py-8">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/faq/:slug" element={<PublicFAQ />} />
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/manual" 
                element={
                  <ProtectedRoute>
                    <ManualDashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/manual/new" 
                element={
                  <ProtectedRoute>
                    <LiveEditManual />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/manual/:id/edit" 
                element={
                  <ProtectedRoute>
                    <LiveEditManual />
                  </ProtectedRoute>
                } 
              />
              <Route path="/manual/:slug" element={<PublicManual />} />
              <Route 
                path="/faq/:id/edit" 
                element={
                  <ProtectedRoute>
                    <FAQEditor />
                  </ProtectedRoute>
                } 
              />
            </Routes>
            </main>
            <Toaster 
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                },
              }}
            />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
